import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  const whatsappNumber = "9133102888";
  const preDefinedMessage = "Hello! welcome to Genetheraptics pharma pvt.ltd.";

  return (
    <section className="whatsapp-section">
      <div className="container text-center">
        <a
          href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
            preDefinedMessage
          )}`}
          className="whatsapp-button"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp />
        </a>
      </div>
    </section>
  );
};

export default WhatsAppButton;